"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M2.624 12.011a.511.511 0 0 1 .726.044l.19.216.094.099L12 20.751l8.365-8.382.138-.146.211-.242.804.66-.084.096c-.08.093-.15.174-.222.252l-.11.114-8.734 8.749a.514.514 0 0 1-.672.054l-.063-.053-8.733-8.75a5.507 5.507 0 0 1-.31-.339.53.53 0 0 1 .035-.753ZM12.71 7.544a.52.52 0 0 1 .454.152l.054.066 2.047 2.943h8.216a.52.52 0 0 1 .093 1.03l-.093.009h-8.487a.518.518 0 0 1-.36-.146l-.066-.077-1.588-2.282-2.065 6.886a.519.519 0 0 1-.888.193l-.053-.071-2.754-4.503H.52a.52.52 0 0 1-.093-1.03l.093-.01h6.99c.152 0 .292.065.39.177l.054.072 2.298 3.759 2.042-6.804a.525.525 0 0 1 .415-.364Zm3.78-5.549c3.592.009 6.514 2.931 6.514 6.513 0 .537-.073 1.089-.215 1.643a.526.526 0 0 1-.633.373.522.522 0 0 1-.373-.633c.12-.467.182-.933.182-1.383 0-3.011-2.456-5.466-5.476-5.474a5.454 5.454 0 0 0-4.097 1.858.538.538 0 0 1-.78.003 5.488 5.488 0 0 0-4.1-1.861c-3.012 0-5.467 2.457-5.474 5.476 0 .449.06.914.18 1.381a.513.513 0 0 1-.055.394.51.51 0 0 1-.448.256.52.52 0 0 1-.503-.391 6.6 6.6 0 0 1-.214-1.642c.009-3.591 2.93-6.513 6.514-6.513 1.676 0 3.265.641 4.487 1.806a6.451 6.451 0 0 1 4.49-1.806Z",
    clipRule: "evenodd"
  })]
});